// extracted by mini-css-extract-plugin
export var primitiveLabel = "_ur-0";